/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import ModalBaseLayout from '../ModalBaseLayout';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {ActionRouteNavigate} from '../../../store/actions/actions-route';

class ModalConfirmRegistration extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center modal-confirm-registration',
      closeButton: true,
      keyboard: true,
    });
  }

  onCloseClick = () => {
    this.props.ActionModalHide();

    if (this.props.redirectPath) {
      this.props.ActionRouteNavigate(this.props.redirectPath);
    }
  };

  render() {
    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container modal-info">
          <div className="modal-content">
            <h3 className="logout-title">Пожалуйста, подтвердите регистрацию по электронной почте.</h3>
            <p>
              Письмо с подтверждением Вашей регистрации отправлено на электронную почту -&nbsp;
              {this.props.email}
              .
            </p>
            <p>
              Проверьте указанную электронную почту и завершите регистрацию, активируя свою учетную запись.
            </p>
            <div className="btn-wrap">
              <button type="button" onClick={this.onCloseClick} className="btn btn-base">Закрыть</button>
            </div>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalConfirmRegistration.propTypes = {};

function mapStateToProps({rModals}) {
  return {
    email: rModals.data.email || '',
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
    ActionRouteNavigate,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalConfirmRegistration);
